
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType120';

const defaultSettings = {
  config: [
    {
      name: '',
      sectionId: '',
      blockType: '',
      desktopTopAdId: '',
      desktopCornerAdId: '',
      mobileAdId: '',
      lazyload: true,
    },
  ],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({});
